module.exports = __webpack_public_path__ + "static/media/gradient.a9654a7c.svg";